import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import { VENUE_TYPES } from "../../../lib/consts/venueTypes";
import Control from "../ControlComponents/Control";
import ClubEntradas from "./ClubEntradas";

/**
 * Selector de Entradas por tipo de tienda (estrangulamiento):
 * - cannabis_club → Control (el POS de siempre, NI SE TOCA)
 * - social_club   → ClubEntradas (página propia del club; se retoca sin
 *   alterar otros tipos de tienda)
 * Escape temporal: /control?legacy=1 fuerza el Control viejo también en el club
 * (red de seguridad mientras ClubEntradas madura; se retira al estabilizar).
 */
export default function ControlByVenueType() {
  const ctx = useContext(UserContext);
  const venueType = ctx?.[11];
  const location = useLocation();
  const legacy = new URLSearchParams(location.search).get("legacy") === "1";

  if (venueType === VENUE_TYPES.SOCIAL_CLUB && !legacy) return <ClubEntradas />;
  return <Control />;
}
